const NAMESPACE = "connectionPropertyEditor";

const KEYS = {
    showLabel: "showLabel",
    httpsRequiredErrorMessage: "httpsRequiredErrorMessage"
};

const MESSAGES = {
    [KEYS.showLabel]: {
        value: "Show",
        comment: "Label for the Add Header button"
    },
    [KEYS.httpsRequiredErrorMessage]: {
        value: "Input must be an HTTPS url.",
        comment: "Label for the HTTPS required error message"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
